export enum CivilStateEnum {
  MARRIED = 'MARRIED',
  DIVORCEE = 'DIVORCEE',
  WINDOWED = 'WINDOWED',
  SINGLE = 'SINGLE',
  IN_RELATIONSHIP = 'IN_RELATIONSHIP',
}
